import apiClient from "../Util/ApiClient";

export default class ProfileApi {

    static getPermissions() {
        return apiClient.get('/profile/permissions')
    }
}